import { FaYoutube, FaInstagram, FaLinkedin } from 'react-icons/fa';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-main">
          <div className="footer-col">
            <div className="footer-logo">
              <img
                src="/logo-white.png"
                alt="PayraBook Logo"
                className="footer-logo-img"
              />
            </div>


          </div>

          <div className="footer-col">
            <h4>Support</h4>
            <h5 className="footer-company"> Vidhema Solutions Pvt Ltd.</h5>
            <p>
              <span className="footer-label">Email:</span>{" "}
              <a href="mailto:sales@vidhema.com" className="footer-company">
                sales@vidhema.com
              </a>
            </p>

          </div>

          <div className="footer-col footer-col-icons">
            <div className="footer-socials">
              <a href="https://www.youtube.com/@vidhematechnologies6060" target="_blank" rel="noreferrer" className="social"><FaYoutube /></a>
              <a href="https://www.instagram.com/vidhematechnologies" target="_blank" rel="noreferrer" className="social"><FaInstagram /></a>
              <a href="https://www.linkedin.com/company/vidhema-technologies/" target="_blank" rel="noreferrer" className="social"><FaLinkedin /></a>

            </div>
          </div>
        </div>

        <div className="footer-bottom">© 2026 Vidhema Solutions Pvt Ltd. All rights reserved.</div>
      </div>
    </footer >
  );
}
